import { useEffect, useState } from 'react';
import { PaymentOrderView } from '../types';
import { establishSessionAndFetchOrder } from '../lib/session';

interface OrderState {
    order: PaymentOrderView | null;
    error: Error | null;
    isLoading: boolean;
}

export const useGiftPaymentOrder = (orderId?: string, requireCsrf = false): OrderState => {
    const [state, setState] = useState<OrderState>({ order: null, error: null, isLoading: true });

    useEffect(() => {
        let active = true;

        if (!orderId) {
            setState({ order: null, error: new Error('주문 번호가 없어요.'), isLoading: false });
            return () => {
                active = false;
            };
        }

        setState({ order: null, error: null, isLoading: true });
        establishSessionAndFetchOrder(orderId, { requireCsrf })
            .then((order) => {
                if (active) setState({ order, error: null, isLoading: false });
            })
            .catch((error: unknown) => {
                if (active) {
                    setState({
                        order: null,
                        error: error instanceof Error ? error : new Error('주문 조회에 실패했어요.'),
                        isLoading: false,
                    });
                }
            });

        return () => {
            active = false;
        };
    }, [orderId, requireCsrf]);

    return state;
};
